var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-custom gutter-b disabled"},[_c('div',{staticClass:"card-body pt-3 pb-0 pl-3"},[_c('b-row',[_c('b-col',{staticClass:"m-5"},[_c('h4',[_c('p',[_vm._v("Allgemeine Daten")])]),_c('div',{staticClass:"border mb-3 p-5"},[_c('ReiseDefaultDataEditForm',{attrs:{"reise":_vm.reise}})],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }